module.exports = __webpack_public_path__ + "img/resonator_1.bdfe07b1.svg";